<template>
    <v-row>
        <v-col cols="auto" align-self="center">
            <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn
                v-on="on"
                icon
                dark
                color="primary"
                @click="SignIn(autoImportConfig)"
                >
                <v-icon dark>mdi-account-key-outline</v-icon>
                </v-btn>
            </template>
            <span>{{ autoImportConfig.emailAccount }}</span>
            </v-tooltip>
        </v-col>
        <v-col cols="auto" align-self="center">
            <v-tooltip top v-if="!loading && autoImportConfig.serviceID == AutoImportSources.OneDrive">
            <template v-slot:activator="{ on }">
                <v-btn
                v-on="on"
                icon
                dark
                color="primary"
                @click="showTreeViewFolders(autoImportConfig)"
                >
                <v-icon dark>mdi-file-tree-outline</v-icon>
                </v-btn>
            </template>
            <span>{{ $t("Site.ContentType.AutoImportConfig.SelectFolder") }}</span>
            </v-tooltip>
        </v-col>
        <v-col cols="1" sm="1" md="1" align-self="center" v-if="loading">
            <v-progress-circular
            :size="20"
            :width="3"
            color="primary"
            indeterminate
            class="align-center"
            ></v-progress-circular>
        </v-col>
        <v-col cols="12" sm="6" md="6" align-self="center" v-if="autoImportConfig.serviceID == AutoImportSources.EmailOffice365">
            <v-select
            :items="autoImportConfig.folderList"
            v-model="autoImportConfig.rootFolder"
            :disabled="autoImportConfig.folderList.length == 0"
            :label="$t('RootFolder')"
            item-value="id"
            item-text="text"
            :error-messages="folderErrors()"
            />
        </v-col>
        <v-col cols="12" sm="4" md="6" align-self="center" v-if="autoImportConfig.serviceID == AutoImportSources.OneDrive">
            <v-text-field
            v-model="autoImportConfig.nameFolder"
            :disabled="true"
            :loading="loading"
            v-bind:label="$t('RootFolder')"
            :error-messages="folderErrors()"
            />
        </v-col>
        <v-col cols="1" sm="1" md="1" align-self="center" v-if="loading">
            <v-progress-circular
            :size="20"
            :width="3"
            color="primary"
            indeterminate
            class="align-center"
            ></v-progress-circular>
        </v-col>
        <v-col
            cols="auto"
            align-self="center"
            v-if="!loading"
        >
            <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn
                v-on="on"
                icon
                dark
                color="primary"
                @click="createFolder(autoImportConfig)"
                v-if="autoImportConfig.serviceID === AutoImportSources.OneDrive"
                :disabled="autoImportConfig.folderList.length == 0"
                >
                <v-icon dark>mdi-folder-plus-outline</v-icon>
                </v-btn>
            </template>
            <span>{{ $t("CreateFolder") }}</span>
            </v-tooltip>
        </v-col>

        <ContentTypeAutoImportConfigModalCreateFolder
            :ref="folderModalKey"
            :serviceId="autoImportConfig.serviceID"
            @on-saved="onFolderCreated"
        />

        <TreeViewFoldersModal
            :ref="treeViewFoldersModalKey"
            :treeItems="treeItems"
            :token="authToken"
            @on-folder-selected="onFolderSelected"
        />
    </v-row>
</template>
<script>
import ContentTypeAutoImportConfigModalCreateFolder from '@/components/administration/contentType/autoImport/ContentTypeAutoImportConfigModalCreateFolder';
import AutoImportSources from '@/ecm/variables/AutoImportSources';
import AutoImportService from '@/services/AutoImportService';
import CloudDriveService from '@/services/CloudDriveService';
import Utils from '@/ecm/common/Utils';
import TreeViewFoldersModal from '@/components/administration/contentType/autoImport/TreeViewFoldersModal.vue';

export default {
    name: 'MicrosoftProvidersConfig',
    components: {
        ContentTypeAutoImportConfigModalCreateFolder,
        TreeViewFoldersModal
    },
    props: {
        validator: {
            type: Object,
            default: () => ({}),
        },
        item: {
            type: Object,
            default: () => ({}),
        }
    },
    created() {
        this.getFoldersFromConfigs();
    },
    watch: {
        loading(newVal) {
            this.$emit('update-loading', newVal);
        }
    },
    data() {
        return {
            autoImportConfig: this.item,
            AutoImportSources: AutoImportSources,
            loading: false,
            folderModalKey: 'folderModalKey',
            treeViewFoldersModalKey: 'treeViewFoldersModalKey',
            treeItems: [],
            authToken: {},
        };
    },
    methods: {
        folderErrors() {
            const errors = [];
            if (!this.validator.rootFolder.$dirty) return errors;
            if (!this.validator.rootFolder.required) {
                errors.push(this.$t('RequiredField'));
            }
            return errors;
        },
        async SignIn(item) {
            const token = await this.PerformCloudStorageSignIn(item);
            if (token) {
                if (item.serviceID == AutoImportSources.OneDrive) {
                    this.loading = true;
                    item.oAuthAccessToken = this.authToken.AccessToken;
                    item.oAuthRefreshToken = this.authToken.RefreshToken;
                    const getFoldersRequest = {
                        RefreshToken: this.authToken.RefreshToken,
                        DocECMContentTypeAutoImportConfigService: item.serviceID,
                    };
                    const foldersResponse = await CloudDriveService.getFolders(getFoldersRequest);
                    item.folderList = foldersResponse.folders;
                    this.treeItems = item.folderList.map(folder => ({
                        id: folder.id,
                        text: folder.text,
                        ...(folder.hasChildren ? { children: [] } : {})
                    }));
                    item.rootFolder = '';
                    const userEmailRequest = {
                        RefreshToken: this.authToken.RefreshToken,
                        DocECMContentTypeAutoImportConfigService: item.serviceID
                    };
                    const userEmail = await CloudDriveService.getUserEmail(userEmailRequest);
                    item.emailAccount = userEmail.email;
                    this.loading = false;
                } else if (item.serviceID == AutoImportSources.EmailOffice365) {
                    this.loading = true;
                    item.oAuthAccessToken = this.authToken.AccessToken;
                    item.oAuthRefreshToken = this.authToken.RefreshToken;
                    item.folderList = await AutoImportService.getOffice365EmailFolders(token);
                    item.rootFolder = '';
                    this.loading = false;
                }
            }
        },
        async PerformCloudStorageSignIn(item) {
            let token = null;
            const userID = this.$store.getters['account/user'].Id;
            let apiUrl = this.$store.getters['account/apiUrl'];
            const parameters = await AutoImportService.getOneDriveEndpointParameters();
            // We need to remove extra slashes at the end of the url, in case of a misconfigured config.json
            apiUrl = apiUrl.replace(/\/+$/, '');

            let url = '';
            if (item.serviceID === AutoImportSources.OneDrive) {
                url = `${parameters.ApiURL}/authorize?client_id=${parameters.ClientID}&scope=offline_access%20user.read%20files.readwrite&response_type=code&state=${userID}&redirect_uri=${apiUrl}/api/auto-import/office365/set-token`;
            } else if (item.serviceID === AutoImportSources.EmailOffice365) {
                url = `${parameters.ApiURL}/authorize?client_id=${parameters.ClientID}&scope=offline_access%20user.read%20mail.ReadWrite&response_type=code&state=${userID}&redirect_uri=${apiUrl}/api/auto-import/office365/set-token`;
            }

            const office365LoginWindow = window.open(url, 'resizable=yes,status=yes,location=yes');

            token = await AutoImportService.getOffice365Token(userID);
            this.authToken = token;
            office365LoginWindow.close();
            return token;
        },
        getFoldersFromConfigs() {
            if (this.autoImportConfig.oAuthRefreshToken != '') {
                this.autoImportConfig.folderList = [];
                const token = {
                    RefreshToken: this.autoImportConfig.oAuthRefreshToken,
                    AccessToken: null,
                };
                this.authToken = token;
                if (this.autoImportConfig.serviceID == AutoImportSources.OneDrive) {
                    this.loading = true;
                    const getFoldersRequest = {
                        RefreshToken: this.autoImportConfig.oAuthRefreshToken,
                        DocECMContentTypeAutoImportConfigService: this.autoImportConfig.serviceID,
                    };
                    CloudDriveService.getFolders(getFoldersRequest)
                        .then((data) => {
                            this.autoImportConfig.folderList = data.folders;
                            this.treeItems = this.autoImportConfig.folderList.map(folder => ({
                                id: folder.id,
                                text: folder.text,
                                ...(folder.hasChildren ? { children: [] } : {})
                            }));
                            this.loading = false;

                            if (this.autoImportConfig.rootFolder !== '') {
                                this.loading = true;
                                const folderNameRequest = {
                                    RefreshToken: this.autoImportConfig.oAuthRefreshToken,
                                    FolderId: this.autoImportConfig.rootFolder,
                                    DocECMContentTypeAutoImportConfigService: this.autoImportConfig.serviceID
                                };

                                CloudDriveService.getFolderName(folderNameRequest)
                                    .then((folderName) => {
                                        this.autoImportConfig.nameFolder = folderName.folderName;
                                        this.loading = false;
                                    });
                            }
                        });
                } else if (this.autoImportConfig.serviceID == AutoImportSources.EmailOffice365) {
                    this.loading = true;
                    AutoImportService.getOffice365EmailFolders(token)
                        .then((data) => {
                            this.autoImportConfig.folderList = data;
                            this.loading = false;
                        })
                        .catch(() => {
                            this.autoImportConfig.rootFolder = '';
                            this.autoImportConfig.oAuthRefreshToken = '';
                            this.loading = false;
                        });
                }
            }
        },
        createFolder(item) {
            this.$refs[this.folderModalKey].show(item.oAuthRefreshToken);
        },
        onFolderCreated() {
            Utils.toast.success(this.$t('SavedSuccessfully'));
            this.getFoldersFromConfigs();
        },
        onFolderSelected(folder) {
            this.autoImportConfig.rootFolder = folder.id;
            this.autoImportConfig.nameFolder = folder.text;
            this.$emit('on-folder-selected', this.autoImportConfig);
        },
        showTreeViewFolders(item) {
            const itemID = item.id > 0 ? item.id : item.uuid;
            this.$refs[this.treeViewFoldersModalKey].show(itemID, item.serviceID);
        },
    }
};
</script>
